import { Component, EventEmitter, Input, Output,LOCALE_ID } from '@angular/core'
import * as moment from 'moment'
import { DateAdapter  , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { Subject } from 'rxjs';


@Component({
	selector: 'atyl-nomade-template-renderer',
	templateUrl: './template-renderer.component.html',
	styleUrls: ['./template-renderer.component.scss'],
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
export class TemplateRendererComponent {
	@Input() form: any
    @Input() saveTriggerSubject: Subject<any>;
    @Input() indexSousForm:any;
	atylComponents: string = ''
	atylTemplate: string = ''
	@Output() formSubmit: EventEmitter<any> = new EventEmitter()
	@Output() submited = new EventEmitter<any>();
	hasPrevButton: boolean = false
	hasNextButton: boolean = false
	
	dateFormDebut: any
	dateFormFin: any
	currentParentForm:any 
	
	constructor() { }
	ngOnInit() {
		this.atylComponents = JSON.stringify(this.form.fields)
		this.atylTemplate = this.form.template
		
		/*
		this.dateFormDebut=new Date();
		this.dateFormFin=new Date();
		*/
		console.log('TemplateRendererComponent',this.form);
		this.dateFormDebut = (this.form.my_demande.demande.date_debut) ? new Date( this.form.my_demande.demande.date_debut) : new Date();
		this.dateFormFin = (this.form.my_demande.demande.date_fin) ? new Date( this.form.my_demande.demande.date_fin) : null;	
		this.currentParentForm =this			
		
	}

	onSubmit(event: any) {
		this.formSubmit.emit({
			values: event,
			form: this.form
		})
	}
	getSubmittedEmitter() {
		return this.submited
	}
	onLoaded(event: any) {
		console.log(event)
	}

}
